import React from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, ActivityIcon, DnaIcon } from 'lucide-react';
export function ImagingEvolutionTimeline() {
  const stages = [{
    icon: SearchIcon,
    label: 'Diagnostic imaging',
    active: false
  }, {
    icon: ActivityIcon,
    label: 'Treatment monitoring',
    active: false
  }, {
    icon: DnaIcon,
    label: 'Translational drug development',
    active: true
  }];
  return <div className="w-full py-6 flex flex-col items-center" data-id="element-84">
      <div className="relative w-full max-w-[280px] flex flex-col space-y-8 mb-6" data-id="element-85">
        {/* Vertical Line */}
        <div className="absolute left-6 top-4 bottom-4 w-0.5 bg-gradient-to-b from-white/10 via-white/10 to-[#4B9FE1]/50" data-id="element-86" />

        {stages.map((stage, i) => {
        const Icon = stage.icon;
        return <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: i * 0.3
        }} className="flex items-center relative z-10" data-id="element-87">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 border ${stage.active ? 'bg-[#4B9FE1]/20 border-[#4B9FE1] text-[#4B9FE1] shadow-[0_0_15px_rgba(75,159,225,0.3)]' : 'bg-white/5 border-white/10 text-slate-400'}`} data-id="element-88">
                <Icon className={stage.active ? 'w-6 h-6' : 'w-5 h-5'} data-id="element-89" />
              </div>
              <div className="ml-4" data-id="element-90">
                <span className={`text-sm font-medium ${stage.active ? 'text-white' : 'text-slate-400'}`} data-id="element-91">
                  Stage {i + 1}
                </span>
                <p className={`text-xs mt-0.5 ${stage.active ? 'text-[#4B9FE1]' : 'text-slate-500'}`} data-id="element-92">
                  {stage.label}
                </p>
              </div>
            </motion.div>;
      })}
      </div>

      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2
    }} className="text-xs text-slate-400 text-center bg-white/5 py-2 px-4 rounded-lg border border-white/10" data-id="element-93">
        Imaging is moving earlier in the development process.
      </motion.p>
    </div>;
}